import { jsx as _jsx } from "react/jsx-runtime";
import { FormItem } from "@vertesia/ui/core";
export function FormLabel({ label, required, children }) {
    return (_jsx(FormItem, { label: label, required: required, children: children }));
}
export function FormHelper({ children }) {
    return (_jsx("p", { className: "mt-2 text-sm text-gray-500", children: children }));
}
export function FormError({ children }) {
    return (_jsx("p", { className: "mt-2 text-sm text-red-600", children: children }));
}
//# sourceMappingURL=fields.js.map